import { mapActions, mapGetters, mapState } from 'vuex';
import electionMapToolbar from '@/components/pages/page-election-map-new/election-map-toolbar/election-map-toolbar.vue';
import electionMapTable from '@/components/pages/page-election-map-new/election-map-table/election-map-table.vue';
import electionMapSpecial from '@/components/pages/page-election-map-new/election-map-special/election-map-special.vue';
import { ElectionMapChartOverall, ElectionMapChartParty, ElectionMapChartSenate } from '@/utils/chart-models';
import overviewMap from '@/components/pages/page-election-map-new/overview-map/overview-map.vue';
import loaderMixin from '@/mixins/loader';
import { roundToTwo } from '@/utils/helpers';

export const CONTRACTS = {
  REPUBLICAN: 'Republican',
  DEMOCRATIC: 'Democratic',
  TRUMP: 'Trump',
};

export const COLOR_INDEXES = {
  LOW: 0,
  MEDIUM: 1,
  HIGH: 2,
};

export const PRICE_FACTORS = {
  DELTA: 0.01,
  LOW: 0.64,
  MEDIUM: 0.79,
  HIGH: 1,
};

export const COLOR_MAP = {
  GRAY: [
    { from: 0, to: PRICE_FACTORS.LOW, color: '#dddddd' },
    { from: roundToTwo(PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: PRICE_FACTORS.MEDIUM, color: '#bbbbbb' },
    { from: roundToTwo(PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: PRICE_FACTORS.HIGH, color: '#888888' },
  ],
  BLUE: [
    { from: 30, to: roundToTwo(30 + PRICE_FACTORS.LOW), color: '#8aafff' },
    { from: roundToTwo(30 + PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: roundToTwo(30 + PRICE_FACTORS.MEDIUM), color: '#5c80dc' },
    { from: roundToTwo(30 + PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: roundToTwo(30 + PRICE_FACTORS.HIGH), color: '#244999' },
  ],
  RED: [
    { from: 40, to: roundToTwo(40 + PRICE_FACTORS.LOW), color: '#ff8b98' },
    { from: roundToTwo(40 + PRICE_FACTORS.LOW + PRICE_FACTORS.DELTA), to: roundToTwo(40 + PRICE_FACTORS.MEDIUM), color: '#ff5865' },
    { from: roundToTwo(40 + PRICE_FACTORS.MEDIUM + PRICE_FACTORS.DELTA), to: roundToTwo(40 + PRICE_FACTORS.HIGH), color: '#d22532' },
  ],
};

export const getColorForPalletteCandidate = (contractName) => {
  const name = (contractName || '').toLowerCase();
  const isRepublican = name.includes(CONTRACTS.REPUBLICAN.toLowerCase()) ||
    name.includes(CONTRACTS.TRUMP.toLowerCase());

  if (isRepublican) {
    return COLOR_MAP.RED;
  }
  return COLOR_MAP.BLUE;
};


export default {
  mixins: [
    loaderMixin,
  ],
  components: {
    electionMapToolbar,
    electionMapTable,
    electionMapSpecial,
    overviewMap,
  },
  data() {
    return {
      type: 'senate',
    };
  },
  computed: {
    ...mapGetters('app', ['isLayoutDesktop']),
    ...mapState('market', [
      'mapStateData', 'mapOverviewData',
      'mapStateDataSenate', 'mapOverviewDataSenate',
    ]),
    ChartClass() {
      if (this.type === 'electoral') {
        return ElectionMapChartParty;
      }
      if (this.type === 'senate') {
        return ElectionMapChartSenate;
      }
      return ElectionMapChartOverall;
    },
  },
  watch: {
    type: {
      handler: 'typeHandler',
      immediate: true,
    },
  },
  methods: {
    ...mapActions('market', [
      'getMapStateData', 'getMapOverviewData',
      'getMapOverviewDataSenate', 'getMapStateDataSenate',
    ]),
    typeHandler() {
      this.loaderAdd();
      if (this.type === 'electoral') {
        this.getMapOverviewData()
          .then(() => this.getMapStateData())
          .then(data => this.createChart(data))
          .then(() => this.loaderRemove())
          .catch(() => this.loaderRemove());
      } else if (this.type === 'senate') {
        this.getMapOverviewDataSenate()
          .then(() => this.getMapStateDataSenate())
          .then(data => this.createChart(data))
          .then(() => this.loaderRemove())
          .catch(() => this.loaderRemove());
      }
    },
    createChart(data) {
      setTimeout(() => {
        this.renderChart(data);
      }, this.ChartClass.renderTimeout());
    },
    renderChart(data) {
      if (!this.$refs.chart) return;
      const group = new this.ChartClass(data);
      group.draw(this.$refs.chart);
    },
    onToggle() {
      this.type = this.type === 'electoral' ? 'senate' : 'electoral';
    },
  },
  created() {
    if (this.$route.query.map) {
      this.type = this.$route.query.map;
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-election-map-new/election-map/election-map.js